module.exports = __webpack_public_path__ + "img/fusee-contact.e53887ec.png";